import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Image,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { Img } from "../../../../content/Content";
import { AiOutlineHeart } from "react-icons/ai";

const CourseDetails = () => {
  return (
    <VStack w="100%">
      {/* top bar */}
      <Stack pb="20px">
        <Text
          fontFamily="'Roboto', sans-serif"
          fontSize="24px"
          fontWeight="700"
          color="rgba(43, 44, 61, 1)"
          py="20px"
        >
          FRx Series : English
        </Text>
        `{" "}
        <Box
          h="275px"
          boxShadow="0px 0px 4px 0px rgba(0, 0, 0, 0.1)"
          borderRadius="32px"
        >
          <Box
            bg="rgba(229, 255, 240, 1)"
            h="177px"
            w="300px"
            display="flex"
            justifyContent="center"
            alignItems="center"
            borderRadius="32px"
          >
            <Image src={Img.chanelLogo1} w="120px" h="101px" />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            px="40px"
            py="20px"
          >
            <Button
              bg="rgba(63, 66, 84, 1)"
              color="rgba(255, 255, 255, 1)"
              w="159px"
              h="43px"
              borderRadius="45px"
            >
              Enroll
            </Button>
            <Button
              w="43px"
              h="43px"
              borderRadius="45px"
              border="1px solid rgba(0, 0, 0, 1)"
              fontSize="18px"
              p="0"
              bg={"transparent"}
            >
              <AiOutlineHeart />
            </Button>
          </Box>
        </Box>
      </Stack>

      {/* seris  */}
      <Stack w="80%" mx="auto" my="50px">
        <Accordion w="100%" borderRadius="10px">
          <AccordionItem
            border={"none"}
            mb="15px"
            bg="rgba(245, 245, 255, 1)"
            borderRadius="10px"
          >
            <AccordionButton h="60px" borderRadius="10px">
              <Box
                as="span"
                flex="1"
                textAlign="left"
                display="flex"
                alignItems="center"
              >
                <Image src={Img.file} />
                <Text
                  px="10px"
                  fontFamily="'Roboto', sans-serif"
                  fontSize="20px"
                  fontWeight="500"
                >
                  100 Series
                </Text>
              </Box>
              <AccordionIcon />
            </AccordionButton>

            <AccordionPanel pb={4}>
              <Box
                display="flex"
                pt="15px"
                alignItems="center"
                w="100%"
                pb="20px"
                borderBottom="1px solid rgba(236, 236, 254, 1)"
              >
                <Image src={Img.play} w="21.67px" h="21.67px" mr="20px" />
                <Text
                  fontFamily="'Roboto', sans-serif"
                  fontSize="20px"
                  fontWeight="500"
                  color="rgba(101, 102, 115, 1)"
                >
                  FRX102-pips, lots & unite
                </Text>
              </Box>

              <Box
                display="flex"
                pt="15px"
                alignItems="center"
                w="100%"
                pb="20px"
                borderBottom="1px solid rgba(236, 236, 254, 1)"
              >
                <Image src={Img.play} w="21.67px" h="21.67px" mr="20px" />
                <Text
                  fontFamily="'Roboto', sans-serif"
                  fontSize="20px"
                  fontWeight="500"
                  color="rgba(101, 102, 115, 1)"
                >
                  FRX102-pips, lots & unite
                </Text>
              </Box>

              <Box
                display="flex"
                pt="15px"
                alignItems="center"
                w="100%"
                pb="20px"
                borderBottom="1px solid rgba(236, 236, 254, 1)"
              >
                <Image src={Img.play} w="21.67px" h="21.67px" mr="20px" />
                <Text
                  fontFamily="'Roboto', sans-serif"
                  fontSize="20px"
                  fontWeight="500"
                  color="rgba(101, 102, 115, 1)"
                >
                  FRX102-pips, lots & unite
                </Text>
              </Box>
            </AccordionPanel>
          </AccordionItem>
          <AccordionItem
            border={"none"}
            mb="15px"
            bg="rgba(245, 245, 255, 1)"
            borderRadius="10px"
          >
            <AccordionButton h="60px" borderRadius="10px">
              <Box
                as="span"
                flex="1"
                textAlign="left"
                display="flex"
                alignItems="center"
              >
                <Image src={Img.file} />
                <Text
                  px="10px"
                  fontFamily="'Roboto', sans-serif"
                  fontSize="20px"
                  fontWeight="500"
                >
                  200 Series
                </Text>
              </Box>
              <AccordionIcon />
            </AccordionButton>

            <AccordionPanel pb={4}>
              <Box
                display="flex"
                pt="15px"
                alignItems="center"
                w="100%"
                pb="20px"
                borderBottom="1px solid rgba(236, 236, 254, 1)"
              >
                <Image src={Img.play} w="21.67px" h="21.67px" mr="20px" />
                <Text
                  fontFamily="'Roboto', sans-serif"
                  fontSize="20px"
                  fontWeight="500"
                  color="rgba(101, 102, 115, 1)"
                >
                  FRX102-pips, lots & unite
                </Text>
              </Box>

              <Box
                display="flex"
                pt="15px"
                alignItems="center"
                w="100%"
                pb="20px"
                borderBottom="1px solid rgba(236, 236, 254, 1)"
              >
                <Image src={Img.play} w="21.67px" h="21.67px" mr="20px" />
                <Text
                  fontFamily="'Roboto', sans-serif"
                  fontSize="20px"
                  fontWeight="500"
                  color="rgba(101, 102, 115, 1)"
                >
                  FRX102-pips, lots & unite
                </Text>
              </Box>

              <Box
                display="flex"
                pt="15px"
                alignItems="center"
                w="100%"
                pb="20px"
                borderBottom="1px solid rgba(236, 236, 254, 1)"
              >
                <Image src={Img.play} w="21.67px" h="21.67px" mr="20px" />
                <Text
                  fontFamily="'Roboto', sans-serif"
                  fontSize="20px"
                  fontWeight="500"
                  color="rgba(101, 102, 115, 1)"
                >
                  FRX102-pips, lots & unite
                </Text>
              </Box>
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem
            border={"none"}
            mb="15px"
            bg="rgba(245, 245, 255, 1)"
            borderRadius="10px"
          >
            <AccordionButton h="60px" borderRadius="10px">
              <Box
                as="span"
                flex="1"
                textAlign="left"
                display="flex"
                alignItems="center"
              >
                <Image src={Img.file} />
                <Text
                  px="10px"
                  fontFamily="'Roboto', sans-serif"
                  fontSize="20px"
                  fontWeight="500"
                >
                  300 Series
                </Text>
              </Box>
              <AccordionIcon />
            </AccordionButton>

            <AccordionPanel pb={4}>
              <Box
                display="flex"
                pt="15px"
                alignItems="center"
                w="100%"
                pb="20px"
                borderBottom="1px solid rgba(236, 236, 254, 1)"
              >
                <Image src={Img.play} w="21.67px" h="21.67px" mr="20px" />
                <Text
                  fontFamily="'Roboto', sans-serif"
                  fontSize="20px"
                  fontWeight="500"
                  color="rgba(101, 102, 115, 1)"
                >
                  FRX102-pips, lots & unite
                </Text>
              </Box>

              <Box
                display="flex"
                pt="15px"
                alignItems="center"
                w="100%"
                pb="20px"
                borderBottom="1px solid rgba(236, 236, 254, 1)"
              >
                <Image src={Img.play} w="21.67px" h="21.67px" mr="20px" />
                <Text
                  fontFamily="'Roboto', sans-serif"
                  fontSize="20px"
                  fontWeight="500"
                  color="rgba(101, 102, 115, 1)"
                >
                  FRX102-pips, lots & unite
                </Text>
              </Box>

              <Box
                display="flex"
                pt="15px"
                alignItems="center"
                w="100%"
                pb="20px"
                borderBottom="1px solid rgba(236, 236, 254, 1)"
              >
                <Image src={Img.play} w="21.67px" h="21.67px" mr="20px" />
                <Text
                  fontFamily="'Roboto', sans-serif"
                  fontSize="20px"
                  fontWeight="500"
                  color="rgba(101, 102, 115, 1)"
                >
                  FRX102-pips, lots & unite
                </Text>
              </Box>
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </Stack>

      {/* Wishlist */}

      <Stack my="50px" w="80%" mx="auto" alignItems="flex-start" textAlign="left" justifyContent="flex-start" 
     >
        <Text
            fontFamily="'Roboto', sans-serif"
            fontSize="24px"
            fontWeight="700"
            color="rgba(43, 44, 61, 1)"
            py="20px"
            textAlign="left"
            w="100%"
            >
            Wishlist
            </Text>

        <Box bg="rgba(245, 245, 255, 1)" p="25px" borderRadius="10px" w="100%"  minH="360px">
            <Text
            fontFamily="'Roboto', sans-serif"
            fontSize="16px"
            fontWeight="600"
            color="rgba(43, 44, 61, 1)"
            py="15px"
            textAlign="left"
            w="100%"
            >
            FRX Series : English
            </Text>

            <Box
                display="flex"
                pt="15px"
                alignItems="center"
                w="100%"
                pb="20px"
                
              >
            <Button
              w="40px"
              h="40px"
              mr="20px"
              borderRadius="45px"
              border="1px solid #7c7c7c"
              fontSize="16px"
              p="0"
              bg={"transparent"}
            >
              <AiOutlineHeart />
            </Button>
                <Text
                  fontFamily="'Roboto', sans-serif"
                  fontSize="14px"
                  fontWeight="500"
                  color="rgba(101, 102, 115, 1)"
                >
                  FRX101- introductions ti trade 
                    overview
                </Text>
            </Box>

            <Box
                display="flex"
                pt="15px"
                alignItems="center"
                w="100%"
                pb="20px"
              >
            <Button
              w="40px"
              h="40px"
              mr="20px"
              borderRadius="45px"
              border="1px solid #7c7c7c"
              fontSize="16px"
              p="0"
              bg={"transparent"}
              color="rgba(255, 164, 164, 1)"
            >
              <AiOutlineHeart />
            </Button>
                <Text
                  fontFamily="'Roboto', sans-serif"
                  fontSize="14px"
                  fontWeight="500"
                  color="rgba(101, 102, 115, 1)"
                >
                  FRX101- introductions ti trade 
                    overview
                </Text>
            </Box>
            <Box
                display="flex"
                pt="15px"
                alignItems="center"
                w="100%"
                pb="20px"
              >
            <Button
              w="40px"
              h="40px"
              mr="20px"
              borderRadius="45px"
              border="1px solid #7c7c7c"
              fontSize="16px"
              p="0"
              bg={"transparent"}
              color="rgba(255, 164, 164, 1)"
            >
              <AiOutlineHeart />
            </Button>
                <Text
                  fontFamily="'Roboto', sans-serif"
                  fontSize="14px"
                  fontWeight="500"
                  color="rgba(101, 102, 115, 1)"
                >
                  FRX101- introductions ti trade 
                    overview
                </Text>
            </Box>
        </Box>    
      </Stack>
    </VStack>
  );
};

export default CourseDetails;
